import Request from '@/plugins/request';

export function getWithdrawals(params) {
  return Request.get('withdrawals', { params })
}

export function createWithdrawals() {
  return Request.get(`withdrawals/create`)
}

export function storeWithdrawals(data) {
  return Request.post('withdrawals', data)
}

export function agree(id, data) {
  return Request.post(`withdrawals/check/${id}`, data)
}

export function disagree(id, data) {
  return Request.post(`withdrawals/check/${id}`, data)
}

export function withdrawalLogsList(params) {
  return Request.post(`withdrawalLog/list`, params)
}


export function apiWithdrawalDetailLogsList(params) {
  return Request.post(`withdrawals-detail/list`, params)
}

export function withdrawal(id) {
  return Request.get(`withdrawals/withdrawal/${id}`)
}

export function withdrawalFailed(id) {
  return Request.get(`withdrawals/withdrawal-failed/${id}`)
}

export function updateWithdrawals(id, data) {
  return Request.put(`withdrawals/${id}`, data)
}

export function editWithdrawals(id) {
  return Request.get(`withdrawals/${id}/edit`)
}

export function destroyWithdrawals(id) {
  return Request.delete(`withdrawals/${id}`)
}

export function exportWithdrawals(params) {
  return Request.get('withdrawals/export', { params })
}
